import { Newspaper } from "lucide-react";
import FolderView from "@/components/FolderView";

const FOLDERS = ["General"];

export default function CurrentAffairs() {
  return (
    <div className="p-6 max-w-6xl mx-auto">
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-red-600 rounded-xl flex items-center justify-center">
            <Newspaper className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="font-['Barlow_Condensed'] text-3xl font-bold text-app tracking-wide">
              CURRENT AFFAIRS
            </h1>
            <p className="text-app">News, updates & current events</p>
          </div>
        </div>
      </div>

      <FolderView subHub="current-affairs" folders={FOLDERS} icon={Newspaper} color="orange" />
    </div>
  );
}
